export default __webpack_public_path__ + "static/media/bannersamboymobile.6036eaac.png";